import React, { createRef } from 'react';
import RuleMap from './rule-map';
import styles from './index.less';
import { Button } from 'antd';

export const PICKER_STATUS = {
  RECOMMEND: 'initial',
  COMPLETE: 'complete',
  EDITING: 'editing',
};

export const DRAG_CHECK_RULES = {
  [PICKER_STATUS.EDITING]: {
    text: '请拖动缩放地图以调整门店位置',
    priority: 100,
    canSubmit: false,
  },
  [PICKER_STATUS.RECOMMEND]: {
    text: '此为推荐位置，请拖动缩放地图以调整门店位置',
    priority: 100,
    canSubmit: false,
  },
  default: {
    text: '注意店铺位置不要标到马路对面去哦',
    priority: 10,
  },
  inWaterCheck: {
    text: '店铺位置不能落在水中，请注意核对哦',
    priority: 90,
    level: 'warn',
  },
  crossRoadCheck: {
    text: '店铺离道路太近了，请注意核对哦',
    priority: 80,
    level: 'warn',
  },
};

export default class MapPicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      latestLocation: { lng: props.lng, lat: props.lat },
      currentLocation: { lng: props.lng, lat: props.lat },
      canSubmit: false,
      status: props.referType === 'add' ? PICKER_STATUS.RECOMMEND : PICKER_STATUS.COMPLETE,
    };
    this.mapRef = createRef();
    this.handleCancel = this.handleCancel.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  panTo(location, source = 'initial') {
    this.mapRef.current.map.panTo([location.lng, location.lat], source);
  }

  handleCancel() {
    this.setState(
      {
        status: PICKER_STATUS.COMPLETE,
        currentLocation: this.state.latestLocation,
      },
      () => {
        this.panTo(this.state.currentLocation, 'default');
        this.emitChange();
      }
    );
  }

  handleConfirm() {
    const { currentLocation, status: currentStatus } = this.state;
    this.setState(
      {
        status: PICKER_STATUS.COMPLETE,
        latestLocation: currentLocation,
      },
      () => {
        if (this.props.onConfirm) {
          this.props.onConfirm({
            longitude: currentLocation.lng,
            latitude: currentLocation.lat,
            status: currentStatus,
          });
        }
        if (this.props.onChange) {
          this.props.onChange(PICKER_STATUS.COMPLETE);
        }
      }
    );
  }

  handleEdit() {
    this.setState(
      {
        status: PICKER_STATUS.EDITING,
      },
      () => {
        this.emitChange();
      }
    );
  }

  emitChange(source = 'edit') {
    if (this.props.onChange) {
      this.props.onChange({
        status: this.state.status,
        currentLocation: this.state.currentLocation,
        source,
      });
    }
  }

  onChange(data) {
    this.setState(
      {
        currentLocation: data.location,
        canSubmit: data.canSubmit,
      },
      () => {
        this.emitChange();
      }
    );
  }

  render() {
    const { currentLocation, status, canSubmit } = this.state;
    const editable =
      !this.props.disabled &&
      (status === PICKER_STATUS.RECOMMEND || status === PICKER_STATUS.EDITING);
    return (
      <>
        <div style={{ display: this.props.nonLngLat ? 'none' : 'block' }}>
          <div className={styles.locationBanner}>
            {status !== PICKER_STATUS.EDITING && this.props.disabledText
              ? this.props.disabledText
              : '如果位置有误将无法通过审核，请仔细核对下图位置，调整后点击确定'}

            <div className={styles.mapControl}>
              {status === PICKER_STATUS.EDITING ? (
                <Button style={{ 'margin-right': '10px' }} size="small" onClick={this.handleCancel}>
                  取消
                </Button>
              ) : null}
              {status === PICKER_STATUS.EDITING || status === PICKER_STATUS.RECOMMEND ? (
                <Button
                  size="small"
                  disabled={!canSubmit || this.props.disabled}
                  type="primary"
                  onClick={this.handleConfirm}
                >
                  确定
                </Button>
              ) : null}
              {status === PICKER_STATUS.COMPLETE ? (
                <Button size="small" onClick={this.handleEdit}>
                  修改
                </Button>
              ) : null}
            </div>
          </div>
          <div
            className={`
            ${styles.mapPicker}
            ${editable ? styles.mapPickerEditable : ''}
          `}
          >
            {this.props.disabled ? (
              <div className={styles.mapCover}>
                <div className={styles.mapCoverText}>请先输入详细地址</div>
              </div>
            ) : null}
            <RuleMap
              ref={this.mapRef}
              checkRules={DRAG_CHECK_RULES}
              lng={currentLocation.lng}
              lat={currentLocation.lat}
              status={status}
              source={this.props.status ? this.props.status.source : 'edit'}
              editable={editable}
              overseasFlag={this.props.overseasFlag}
              onZoom={this.props.onZoom}
              onChange={this.onChange}
            />
          </div>
        </div>
      </>
    );
  }
}
